/**
 * Shared voice config for the agent-console voice doors (Quality Co-Pilot, Tech
 * Support Co-Pilot). The Google Cloud TTS voice allowlist mirrors the backend's
 * curated set in services/voice/gcp_tts.py (GCP_VOICES) — Chirp 3 HD is Google's
 * newest tier and the default. Pure module so both pages can share it.
 */
export interface GcpVoiceOption {
  name: string;
  label: string;
}

export const GCP_VOICES: ReadonlyArray<GcpVoiceOption> = [
  { name: 'en-US-Chirp3-HD-Aoede', label: 'Aoede — female (HD)' },
  { name: 'en-US-Chirp3-HD-Charon', label: 'Charon — male (HD)' },
  { name: 'en-US-Chirp3-HD-Despina', label: 'Despina — female (HD)' },
  { name: 'en-US-Chirp3-HD-Achird', label: 'Achird — male (HD)' },
  { name: 'en-US-Chirp3-HD-Callirrhoe', label: 'Callirrhoe — female (HD)' },
  { name: 'en-US-Neural2-F', label: 'Neural2 — female' },
  { name: 'en-US-Studio-O', label: 'Studio — female (narration)' },
];

export const DEFAULT_VOICE = 'en-US-Chirp3-HD-Aoede';

/** "1.3×" / "1×" / "0.85×" — trims trailing zeros for a speed-slider readout. */
export function formatSpeed(rate: number): string {
  return `${rate.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')}×`;
}
